// @flow

// Libs
import React from 'react'
import _map from 'lodash/map'

// icons
import ArrowDown from 'fc-icons/src/ArrowDown'
import ArrowUp from 'fc-icons/src/ArrowUp'

// Styles
import { grey, white } from 'hfty-styles/src/colors'

import Value from './Value'

const styles = {
  container: {
    width: '95%',
    margin: '5px 2.5%',
    boxShadow: '0px 1px 4px rgba(0,0,0,0.2)',
  },
  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    position: `relative`,
    backgroundColor: grey(),
    padding: 8,
  },
  header: {
    color: 'white',
    fontWeight: 500,
  },
  data: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'spaceBetween',
    width: '100%',
    backgroundColor: white(),
    zIndex: 2,
  },
  row: {
    justifyContent: 'space-between',
    padding: 5,
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'right',
  },
}

// Types
type Props = {
  columns: Array<Object>,
  defaultColumn: string,
  record: Object,
  toggled: boolean,
  onToggle: Function,
  renderer: Function,
}

export default class ListItem extends React.Component {
  props: Props

  onToggle: Function

  state: {
    toggled: boolean
  }

  constructor (props: Object) {
    super(props)
    this.state = {toggled: false}
    this.onToggle = this.onToggle.bind(this)
  }

  onToggle () {
    this.setState({
      toggled: !this.state.toggled,
    })
  }

  renderData (): React.Element<any> {
    const { columns, defaultColumn, record, renderer } = this.props
    return (
      <div style={styles.data}>
        {_map(columns, (columnObj: Object): ?React.Element<any> => (
          columnObj.attr !== defaultColumn
            ? <div key={columnObj.attr} style={styles.row}>
              <div>{columnObj.attr}</div>
              <div>
                <Value record={record} attr={columnObj.attr} renderer={renderer} />
              </div>
            </div> : null
        ))}
      </div>
    )
  }

  renderHeader (): React.Element<any> {
    const {defaultColumn, record} = this.props
    return (
      <div style={styles.header}>
        {record[defaultColumn]}
      </div>
    )
  }

  render (): React.Element<any> {
    return (
      <div style={styles.container} >
        <div style={styles.headerContainer} >
          {this.renderHeader()}
          <div onClick={this.onToggle}>
            {this.state.toggled ? <ArrowUp color={'white'} size={20} /> : <ArrowDown color={'white'} size={20} />}
          </div>
        </div>
        {this.state.toggled
          ? this.renderData() : null}
      </div>
    )
  }
}
